import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SETTINGS } from '../../../core/config/common.settings';
import { AppUtils } from '../../../core/config/app.utils';
import { FilesService } from '../../../core/services/files.service';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AgentService } from '../../../core/services/agent.service';

const AGENT_ADD_EDIT_POPUP_ATTACHMENT = 'AGENT_ADD_EDIT_POPUP_ATTACHMENT';

@Component({
  selector: 'app-add-agent-popup',
  templateUrl: './add-agent-popup.component.html',
  styleUrls: ['./add-agent-popup.component.scss'],
})
export class AddAgentPopupComponent implements OnInit {
  @Output() addEditAgentOnChange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible = false;

  agentForm: FormGroup | any;
  formErrors: any;
  attachments: any[] = [];
  attachmentUploading = false;

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private message: NzMessageService,
    private agentService: AgentService,
  ) {
    this.formErrors = {
      name: {},
      contactNo: {},
      email: {},
      category: {},
    };
  }

  ngOnInit(): void {
    this.uploadLoader();
    this.initAgentForm();
  }

  uploadLoader() {
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case AGENT_ADD_EDIT_POPUP_ATTACHMENT:
          this.attachmentUploading = res.loading;
          break;
      }
    });
  }

  initAgentForm(): void {
    this.agentForm = this.fb.group({
      category: [null, [Validators.required]],
      name: [
        null,
        [
          Validators.required,
          Validators.maxLength(70),
          // Updated pattern to allow letters, numbers, and special characters
          Validators.pattern(/^[a-zA-Z0-9\s!@#$%^&*()_+=\-\\[\]{};':"\\|,.<>\/?]+$/),
        ],
      ],
      contactNo: [
        null,
        [
          Validators.required,
          Validators.maxLength(15),
          Validators.pattern(/^\d+$/),
        ],
      ],
      email: [
        null,
        [Validators.required, Validators.maxLength(100), Validators.email],
      ],
    });

    this.agentForm.valueChanges.subscribe((values: any) => {
      this.formErrors = AppUtils.getFormErrors(this.agentForm, this.formErrors);
    });
  }

  upload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, AGENT_ADD_EDIT_POPUP_ATTACHMENT)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.attachments.push({ name: data.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: AGENT_ADD_EDIT_POPUP_ATTACHMENT,
          loading: false,
        });
      });

  cancel(): void {}

  confirm(): void {
    this.isVisible = false;
    this.addEditAgentOnChange.emit({ name: 'isVisible', value: false });
  }

  onSubmit(): void {
    this.agentService
      .createAgent({
        ...this.agentForm.value,
        attachments: this.attachments,
      })
      .subscribe(
        () => {
          this.agentForm.reset();
          this.attachments = [];
          this.isVisible = false;
          this.addEditAgentOnChange.emit({
            name: 'created',
            value: false,
          });
        },
        (e: any) => {
          if (e?.error?.errors?.email) {
            this.message.create('error', `Email is already existing!`);
          }
        },
      );
  }

  confirmRemoveAttachment(index: any): void {
    this.attachments.splice(index, 1);
    this.message.create('success', `Attachment has been deleted!`);
  }

  onCancelConfirm(): void {
    this.agentForm.reset();
    this.attachments = [];
    this.isVisible = false;
    this.addEditAgentOnChange.emit({
      name: 'isVisible',
      value: false,
    });
  }

  handleCancel(): void {
    this.agentForm.reset();
    this.attachments = [];
    this.isVisible = false;
    this.addEditAgentOnChange.emit({
      name: 'isVisible',
      value: false,
    });
  }

  handleOk(): void {}
}
